import React, { useEffect } from "react";
import propTypes from "prop-types";
import { pageType } from "constants/app";
import HeaderComponent from "components/Layout/HeaderComponent";
import { getStorageData } from "utils/helper";
import FooterComponent from "components/Layout/FooterComponent";
import ClinksOrgDetails from "containers/ClinksOrgDetails";
import classNames from "classnames";
import { DOMAIN_CLINKS, DOMAIN_MTC } from "constants/app";
import { useStyles } from "./styles";

const SearchClinksOrgDetails = (props) => {
  const classes = useStyles(props);
const domain = getStorageData("domain");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div
      className={classNames(classes.orgdetails__page, `orgdetails__pageCommon ${domain === DOMAIN_CLINKS ? 'orgdetails__clinks' : 'orgdetails__mtc'}`)}
    >
      <HeaderComponent
        className={`${domain === DOMAIN_CLINKS ? 'bg-brand-primary' : 'bg-white'}`}
        isPage={pageType.details}
        {...props}
      />
      <ClinksOrgDetails {...props} />
      <FooterComponent />
    </div>
  );
};
SearchClinksOrgDetails.propTypes = {
  history: propTypes.object,
};
export default SearchClinksOrgDetails;
